<template>
    <div class="card-container">
        <div>
            <p class="card-container--date">{{getDay}}</p>
            <p class="card-container--month">{{getMonth}}</p>
        </div>
        <div class="event-container">
            <p class="card-container--events-name">{{item.name}}</p>
            <p class="card-container--days" :class="{'green-text': lessThanSevenDaysRemaining}">{{ item.expiry_string}}</p>
        </div>
        <div class="card-container--actions" style="margin-left: 10px">
            <img class="card-container--action-icons mr-4" @click="toggleEditGiftModal" src="~@/assets/images/decoration/edit.svg" alt="edit-button">
            <img class="card-container--action-icons" @click="toggleRemoveGiftModal" src="~@/assets/images/decoration/delete.svg" alt="remove-button">
        </div>
        <remove-date-modal v-if="showRemoveGiftModal" @closed="toggleRemoveGiftModal" :editData="item"/>
        <add-date-modal v-if="showEditGiftModal" @closed="toggleEditGiftModal" :editData="item"/>
    </div>
</template>

<script>
import { format } from 'date-fns';
import AddDateModal from '@/components/partials/account/special-dates/AddDateModal';
import RemoveDateModal from '@/components/partials/account/special-dates/RemoveDateModal';

export default {
    components: { AddDateModal, RemoveDateModal },
    name: 'GiftingRemindersCard',
    props: {
        item: {
            require: true,
            type: Object,
        },
    },
    data() {
        return {
            showRemoveGiftModal: false,
            showEditGiftModal: false,
            isProcessing: false,
        };
    },
    computed: {
        date() {
            return new Date(this.item.date);
        },
        getDay() {
            return format(this.date, 'dd');
        },
        getMonth() {
            return format(this.date, 'MMM').toUpperCase();
        },
        deleteButtonText() {
            return this.isProcessing ? this.$t('SPECIAL_DATES_WAIT') : this.$t('SPECIAL_DATES_DELETE');
        },
        lessThanSevenDaysRemaining() {
            const daysToGo = this.item.expiry_string.split(' ')[0];
            return daysToGo >= 10;
        },
    },
    methods: {
        toggleRemoveGiftModal() {
            return this.showRemoveGiftModal = !this.showRemoveGiftModal;
        },
        toggleEditGiftModal() {
            return this.showEditGiftModal = !this.showEditGiftModal;
        },
    },
};
</script>

<style lang="scss" scoped>
    .card-container {
        display: flex;
        align-items: center;
        flex-direction: row;
        padding: 0px 34px;
        min-width: 327px;
        min-height: 101px;
        border-radius: 3px;
        border: 1px solid #262323;

        &--date {
            color: #262323;
            font-style: normal;
            font-weight: 400;
            font-size: 23px;
            margin-bottom: 0px;
        }

        &--month {
            font-style: normal;
            font-weight: 400;
            font-size: 11px;
            color: #262323;
            margin-top: 0px;
        }

        &--events-name {
            font-weight: 400;
            font-size: 16px;
            line-height: 19px;
            color: #262323;
        }

        &--days {
            font-size: 14px;
            font-style: italic;
            font-weight: 400;
            line-height: 17px;
            letter-spacing: 0em;
            text-align: left;
            color: #AD493F;
        }

        &--actions {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
        }

        &--action-icons {
            height: 18.846240997314453px;
            width: 16.47433090209961px;
            left: 307.46875px;
            top: 41.28515625px;
            border-radius: 0px;
            cursor: pointer;
        }
    }

    @media (min-width: 1024px){
        .card-container {
            min-width: 352px;
            min-height: 120px;
            justify-content: center;
        }

    }
    .event-container {
        margin: 0px 20px;
        width: 200px
    }

    .green-text {
        color: green;
    }
</style>
